// modules
import React from 'react'
import { renderRoutes } from 'react-router-config'

// components
import ConfigProvider from 'antd-v3/es/config-provider'
import Layout from 'antd-v3/es/layout'
import ErrorBoundary from 'src/components/ErrorBoundary'
import PredefinedEmpty from 'src/components/PredefinedEmpty'

// styles
import '../../dependencies'
import 'src/assets/styles/main.pcss'

const SimpleLayout = ({ route = null }) => {
  const routes = route?.routes || {}

  return (
    <Layout className="simple-layout">
      <ConfigProvider renderEmpty={PredefinedEmpty}>
        <ErrorBoundary>{renderRoutes(routes)}</ErrorBoundary>
      </ConfigProvider>
    </Layout>
  )
}

export default SimpleLayout
